import { styled } from "@mui/material/styles";

const LogoImage = styled("img")({
  height: "40px",
  marginLeft: "16px",
  marginRight: "16px",
});

export default LogoImage; 